




import {Vue, Component, Watch} from 'vue-property-decorator';
import {nil} from '@/common';
@Component({
    components: {
    },
})
export default class SingleAndMultiDashboardPage extends Vue {
    public viewingItem = false;
    public itemBeingViewed = null;
    public feathersModel!: any;
    public routeParameter!: string;
    public redirectOnMulti = false;
    public mounted() {
        this.initialize();
    }
    @Watch('$route')
    public onRouteChanged(value: string, oldValue: string) {
        this.initialize();
    }
    private initialize() {
        this.viewingItem = !nil(this.itemRouteParameter);
        if (this.viewingItem) {
            this.refreshItem();
        } else if (this.redirectOnMulti) {
            this.$router.replace('');
        }
    }
    public async refreshItem() {
        this.itemBeingViewed = await this.feathersModel.get(this.itemRouteParameter);
    }
    public get itemRouteParameter() {
        return this.$route.params[this.routeParameter];
    }
    public get hasItem() {
        return !nil(this.itemBeingViewed);
    }
}
